import React, { useContext, useEffect, useRef, useState } from "react";
import { FaToggleOff, FaToggleOn } from "react-icons/fa";
import { AiOutlineAppstore, AiOutlineTag } from "react-icons/ai";
import { AiOutlineFullscreen } from "react-icons/ai";
import { SlNotebook } from "react-icons/sl";
import { CiSettings } from "react-icons/ci";
import logo from "../assest/logo.png";
import { MdNotifications } from "react-icons/md";
import { MdNotificationsActive } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storeLogout } from "../store/slices/storeSlice";
import { CiMenuKebab } from "react-icons/ci";
import { CiMenuBurger } from "react-icons/ci";
import { setToggleTheme } from "../store/slices/themeSlice";
import LangaugeSelector from "./languageSelector/LangaugeSelector";
import Tooltip from "./Tooltip/Tooltip";
import { useSocket } from "./Socket/SocketProvider";
import { NotificationApi } from "../apis/Notification.api";
import Notification from "../pages/Notification";
import LoaderContext from "./loader/LoaderContext";
import NotificationBell from "./Notification/NotificationBell";
import { useNotification } from "./contexts/NotificationContext";

const Topbar = ({ handleSidebar }) => {
  const { notificationData,status, updateNotification, handleMarkAllAsRead } =
    useNotification();
  const navigate = useNavigate();
  const notificationRef = useRef(null);
  const [isNotification, setIsNotification] = useState(false);
  // const [notificationData, setNotificationData] = useState([]);
  const [newNotiCount, setNewNotiCount] = useState(null);
  const [notification, setNotification] = useState(false);
  const { currentUser } = useSelector((state) => state.store);
  const [ApprovalStatus, setApprovalStatus] = useState(false);
  const userName = currentUser && currentUser?.first_name;
  const profileRef = useRef(null);
  const menuRef = useRef(null);
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.theme);
  const [showProfile, setShowProfile] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const {handleLoading} = useContext(LoaderContext)
  const [show, setShow] = useState(false);
  console.log("status:",status)
  useEffect(() => {
    if (status) {
      setShow(true);

      // Auto close after 3 seconds
      const timer = setTimeout(() => {
        setShow(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [status]);
  console.log("notificationData:",notificationData)

  const markAllAsRead = async () => {
    try {
      await NotificationApi.markAllAsRead();
      // getNotification();
    } catch (err) {
      console.error("Error marking all as read:", err);
    }
  };

  const viewAllNotifications = () => {
    navigate("/notifications");
    setNotification(false);
  };

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }

  useEffect(() => {
    if (isNotification) {
      setNotification(true);
    }
  }, [isNotification]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setApprovalStatus(
      !(currentUser?.status === "Pending" || currentUser?.status === "Pending")
    );
  }, [currentUser?.status]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDark = () => {
    dispatch(setToggleTheme("dark"));
  };

  const handleLight = () => {
    dispatch(setToggleTheme("light"));
  };

  // const getNotification = async (id) => {
  //   const payload = {
  //     is_read: true,
  //   };
  //   // handleLoading(true)
  //   try {
  //     const res = id
  //       ? await NotificationApi.updateNotification(id, payload)
  //       : await NotificationApi.getAllNotification();
  //     const newNotifications = res.data.data.allNotifications;
  //     const newCount = newNotifications.filter(
  //       (newNoti) =>
  //         !notificationData.some((oldNoti) => oldNoti.id === newNoti.id) &&
  //         !newNoti.is_read
  //     ).length;

  //     const newNoti = newNotifications.filter((newNoti) => !newNoti.is_read);

  //     setNotificationData(newNoti);
  //     setNewNotiCount(newCount);
  //   } catch (err) {
  //     console.error("error:", err);
  //   }

  // };

  const handleNotiBoxClick = (noti) => {
    navigate(`/store/order/all-orders`);
    setNewNotiCount(null);
    // getNotification(noti._id);
  };

  useEffect(() => {
    // getNotification();

    // const interval = setInterval(() => {
    //   getNotification();
    // }, 5000);

    // return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`${theme === "light"
          ? "bg-secondaryColor text-primaryColor"
          : "bg-darkThirsary text-darkSecondary"
        } shadow-md h-16 w-full flex items-center justify-between px-5 py-12 fixed z-20`}
    >
      <div className="flex gap-7">
        <span
          className="cursor-pointer flex  justify-between items-center"
          onClick={handleSidebar}
        >
          <CiMenuKebab className="font-black" />
          <CiMenuBurger className="font-black" />
        </span>

        <LangaugeSelector />
      </div>

      <div>
        <img src={logo} alt="Logo" width={175} />
      </div>
      <div className="flex gap-3 text-xl items-center">
        {!ApprovalStatus ? (
          <span className=" flex justify-center items-center cursor-pointer text-hoverColor hover:text-hoverColor">
            <i> Your Account is unapproved</i>
            <Tooltip
              position="bottom"
              text={
                <>
                  <li>Upload Documents</li>
                  <li>Update Bank details</li>
                </>
              }
            />
          </span>
        ) : (
          ""
        )}
        {/* Notifications */}
        <div
          className="relative text-gray-700 mt-[10px]"
          onMouseEnter={() => {
            setNotification(true);
            setIsNotification(false);
          }}
          ref={notificationRef}
        >
          {/* {isNotification ? (
            <MdNotificationsActive className="text-2xl shake" />
          ) : (
            <div className="relative inline-block">
              {newNotiCount > 0 && (
                <p className="absolute -top-2 -right-2 bg-RedColor text-white text-xs font-bold px-2 py-0.5 rounded-full">
                  {newNotiCount}
                </p>
              )}
              <MdNotifications className="text-2xl" />
            </div>
          )} */}

          {/* {notification && (
            <Notification
              theme={theme}
              notificationData={notificationData}
              handleNotiBoxClick={handleNotiBoxClick}
              markAllAsRead={markAllAsRead}
              viewAllNotifications={viewAllNotifications}
            />
          )} */}
        </div>
          <NotificationBell userId={currentUser?._id} />
           {show&&( <div className="fixed top-5 right-5 z-50">
      <div className="bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg animate-slide-in">
        {status}
      </div>
    </div>)}
        <div className="hidden md:flex gap-3 text-xl items-center">
          {theme === "light" ? (
            <FaToggleOff
              className="cursor-pointer hover:text-hoverColor text-3xl"
              onClick={handleDark}
            />
          ) : (
            <FaToggleOn
              className="cursor-pointer hover:text-hoverColor text-3xl"
              onClick={handleLight}
            />
          )}
          {ApprovalStatus ? (
            <div onClick={() => setShowMenu(!showMenu)}>
              <AiOutlineAppstore className="cursor-pointer relative hover:text-hoverColor" />
              {showMenu ? <MenuDD ref={menuRef} /> : null}
            </div>
          ) : (
            ""
          )}
          <AiOutlineFullscreen
            className="cursor-pointer hover:text-hoverColor"
            onClick={toggleFullScreen}
          />
        </div>
        <div
          className="flex items-center gap-2 cursor-pointer hover:text-hoverColor "
          onClick={() => setShowProfile(!showProfile)}
        >
          <span className="text-sm text-bluefont hidden md:flex capitalize ">
            {userName}
          </span>
          <div className="relative ">
            <img
              src={logo}
              alt="Logo"
              width={40}
              className=" rounded-full border "
            />
            {showProfile ? (
              <ProfileDD ApprovalStatus={ApprovalStatus} ref={profileRef} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;

const ProfileDD = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { socket } = useSocket();

  const { theme } = useSelector((state) => state.theme);
  const handleLogout = async () => {
    const payload = { payload: null, token: false };
    dispatch(storeLogout(payload));
    socket.off();
    socket.disconnect();
  };
  return (
    <div
      ref={ref}
      className={` ${theme === "light"
          ? "bg-secondaryColor text-primaryColor"
          : "bg-darkPrimary text-darkSecondary"
        } border absolute right-0 shadow-sm mt-2 rounded-lg text-sm w-44`}
    >
      {props.ApprovalStatus ? (
        <ul>
          <li
            className={`cursor-pointer py-2 px-4 ${theme === "light"
                ? "hover:bg-[#f8f8f8]"
                : "hover:bg-thirsaryColor"
              }`}
            onClick={() => navigate("profile")}
          >
            Account
          </li>
          <li
            className={`cursor-pointer py-2 px-4 ${theme === "light"
                ? "hover:bg-[#f8f8f8]"
                : "hover:bg-thirsaryColor"
              }`}
            onClick={() => navigate("offers/promocode")}
          >
            Offers
          </li>
          <li
            className={`cursor-pointer py-2 px-4 ${theme === "light"
                ? "hover:bg-[#f8f8f8]"
                : "hover:bg-thirsaryColor"
              }`}
            onClick={() => navigate("order/delivered-orders")}
          >
            History
          </li>
        </ul>
      ) : (
        ""
      )}
      <div
        className={`border-t cursor-pointer py-2 px-4 ${theme === "light" ? "hover:bg-[#f8f8f8]" : "hover:bg-thirsaryColor"
          }`}
        onClick={handleLogout}
      >
        Sign Out
      </div>
    </div>
  );
});

const MenuDD = React.forwardRef((props, ref) => {
  const { theme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  return (
    <div
      ref={ref}
      className={`${theme === "light"
          ? "bg-secondaryColor text-primaryColor"
          : "bg-darkPrimary text-darkSecondary"
        } border top-10 mt-5 right-40 mr-10  absolute  shadow-sm  rounded-lg text-sm w-fit `}
    >
      <div className="flex">
        <div
          className="lg:flex hidden   py-4 px-6 gap-2 items-center border-b  border-slate-100 flex-col cursor-pointer  hover:text-hoverColor hover:font-semibold"
          onClick={() => navigate("order/all-orders")}
        >
          <p className="text-3xl">
            <SlNotebook />
          </p>
          <p className="text-[12px]">Order</p>
        </div>
        {/* <div
          className="lg:flex hidden   py-4 px-6 gap-2  items-center border-b  border-slate-100 flex-col cursor-pointer text-secondaryfont hover:text-hoverColor hover:font-semibold"
          onClick={() => navigate("earning/current-week")}
        >
          <p className="text-3xl">
            <GiCoins />
          </p>
          <p className="text-[12px] ">Earning</p>
        </div> */}
        <div
          className="lg:flex hidden   py-4 px-6 gap-2  items-center border-b  border-slate-100 flex-col cursor-pointer text-secondaryfont hover:text-hoverColor hover:font-semibold"
          onClick={() => navigate("offers/promocode")}
        >
          <p className="text-3xl">
            <AiOutlineTag />
          </p>
          <p className="text-[12px] ">Offers</p>
        </div>
      </div>
      <div className="flex">
        <div
          className="lg:flex hidden   py-4 px-6 gap-2  items-center border-b  border-slate-100 flex-col cursor-pointer text-secondaryfont hover:text-hoverColor hover:font-semibold"
          onClick={() => navigate("settings/store-settings")}
        >
          <p className="text-3xl">
            <CiSettings />
          </p>
          <p className="text-[12px] ">Settings</p>
        </div>
        <div
          className="lg:flex hidden   py-4 px-6 gap-2  items-center border-b  border-slate-100 flex-col cursor-pointer text-secondaryfont hover:text-hoverColor hover:font-semibold"
          onClick={() => navigate("menu/item-list")}
        >
          <p className="text-3xl">
            <SlNotebook />
          </p>
          <p className="text-[12px] ">Menu</p>
        </div>
      </div>
    </div>
  );
});
